import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { PipesModule } from "@vattenfall/core";
import { UiModule } from "@vattenfall/ui";

import { MySelectConsumptionIntervalFormComponent } from "./my-select-consumption-interval-form.component";

@NgModule({
  declarations: [MySelectConsumptionIntervalFormComponent],
  imports: [CommonModule, FormsModule, PipesModule, UiModule],
  bootstrap: [MySelectConsumptionIntervalFormComponent],
})
export class MySelectConsumptionIntervalFormModule {}
